import { danmaku } from "@/mocks/content";

export default function Danmaku() {
  return (
    <section id="memes" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 md:gap-12">
          <div className="flex flex-col justify-center">
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-chat-smile-3-fill"></i>
              弹幕梗汇总
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              一句话，点燃全场气氛
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              追番的时候弹幕才是本体。我们把那些刷屏的经典弹幕梗整理成册，
              从“嘴遁最强”到“走正门是不可能走正门的”，每个梗背后都是乐子人的集体智慧。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 text-sm text-secondary-800">
                <i className="ri-fire-line"></i>
                2100+ 条梗
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-md bg-primary-100 px-3 py-1.5 text-sm text-primary-700">
                <i className="ri-time-line"></i>
                每日更新
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3">
            {danmaku.map((d, i) => (
              <div
                key={i}
                className="flex items-start gap-3 rounded-lg border border-background-200/80 bg-background-50 p-4"
              >
                <span className="mt-0.5 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-secondary-500 text-xs font-medium text-background-50">
                  {i + 1}
                </span>
                <p className="text-sm leading-relaxed text-foreground-800">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}